import { Command } from "@/app/common/base/command"

export class WoongarantDownloadDocumentCommand extends Command {

    public async run(apiId: string): Promise<void> {
        const response = await this.client.download(
            `/api/products/woongarant-insurances/download/${apiId}`,
            {
                responseType: 'blob',
                timeout: 30000
            },
            true
        )

        let filename = ''
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(disposition)
            if (matches?.[1]) {
                filename = matches[1].replace(/['"]/g, '')
            }
        }
        const fileURL = window.URL.createObjectURL(response.data)
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(fileLink)
        fileLink.click()
    }

}
